






import config from '@/config';
import {
computed,
defineComponent, onMounted, onUnmounted,
ref,
watch
} from '@vue/composition-api';
import firebase from 'firebase/compat/app';
import Postmate from 'postmate';

type RouteChange = {
  toPath: string
};

export default defineComponent({
  name: 'ConversationProviderSettingsPage',
  setup(_, ctx) {
    const childApp = ref<any>(null)
    const cpSettingsPageRef = ref<any>()
    const routeName = computed(() => ctx.root.$route.name)
    const openSuggestionPanel = ref(false)

    function getToken() {
      return firebase.auth()?.currentUser?.getIdToken()
    }

    const user = computed(() => {
      return ctx.root.$store.state.user.user
    })

    const location = computed(() => {
      return ctx.root.$store.state.locations.currentLocation
    })

    const sidebarVersion = computed(() => {
      return ctx.root.$store.getters['sidebarv2/getVersion']
    })

    const getResolvedRoute = (route: string) => {
      const updateRouteUrl =
        sidebarVersion.value === 'v2'
          ? `/v2${route}`
          : route

      return { resolvedRoute: ctx.root.$router.resolve(updateRouteUrl), updateRouteUrl }
    }

    const handleRouting = (data: RouteChange) => {
      const { resolvedRoute, updateRouteUrl } = getResolvedRoute(data.toPath);
      if (resolvedRoute.route.name) {
        ctx.root.$router.push(updateRouteUrl);
      } else {
        console.warn('Blogs: Invalid route')
      }
    }

    onMounted(() => {
      loadMicroApp()
    })

    async function loadMicroApp() {
      if (!routeName) return
      const userId = user.value.id
      const userEmail = user.value.email
      const params = {
        userId,
        userEmail,
        token: await getToken(),
        locationId: location.value.id,
        timezone: location.value.timezone,
        companyId: location.value.company_id,
        appType: 'EMBED',
      }

      if (process.env.NODE_ENV === 'development') {
        Postmate.debug = false
      }
      const appURL = `${config.conversationsAppUrl}${ctx.root.$route.path}`
      cpSettingsPageRef.value.innerHTML = ''
      const handshake = new Postmate({
        container: cpSettingsPageRef.value as HTMLElement,
        url: appURL,
        name: 'conversations-app',
        model: params,
      })

      if (handshake) {
        handshake
          .then((child: any) => {
            child.on('route-change', (data: RouteChange) => {
              handleRouting(data)
            })
            child.on('refresh-token', async () => {
              child.call('updated-token', await getToken())
            })
            child.on('send-feedback', () => {
              openSuggestionPanel.value = true
            })
          })
          .catch(async (err: Error) => {
            console.error('Conversations app APP handshake failed', { handledError: err })
            cpSettingsPageRef.value.innerHTML = ''
            await loadMicroApp()
          })
        childApp.value = handshake
      } else {
        alert('Something went wrong. Please try again.')
      }
    }

    function destroyApp() {
      return new Promise((resolve: any) => {
        if (childApp.value) {
          childApp.value.then((child: any) => {
            child.destroy()
            childApp.value = null
          })
        }
        resolve()
      })
    }

    async function reloadApp() {
      await destroyApp()
      await loadMicroApp()
    }

    onUnmounted(() => {
      destroyApp()
    })

    watch(routeName, reloadApp)

    return {
      cpSettingsPageRef,
      reloadApp,
      location,
      openSuggestionPanel
    }
  },
  watch: {
    '$route.params.location_id': function () {
      this.reloadApp()
    },
  },
})
